import { render, staticRenderFns } from "./HomeNewOrEdit.vue?vue&type=template&id=47b61446&scoped=true&"
import script from "./HomeNewOrEdit.vue?vue&type=script&lang=js&"
export * from "./HomeNewOrEdit.vue?vue&type=script&lang=js&"
import style0 from "./HomeNewOrEdit.vue?vue&type=style&index=0&id=47b61446&prod&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "47b61446",
  null
  
)

export default component.exports